const getUniqueNameFromTrade = trade =>
  trade.unique_name || trade.uniqueName || '';

export default getUniqueNameFromTrade;
